import { Link } from 'expo-router';
import { Text, View } from 'react-native';

export default function NotFoundScreen() {
  return (
    <View className="flex flex-1 flex-col items-center justify-center p-5">
      <Text className="text-xl font-bold">This screen does not exist.</Text>
      <Link href="/" className="mt-4 text-accent">
        Go to home
      </Link>
    </View>
  );
}
